import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { QuickReplyState } from '../../types'

export const deleteQuickReplyAction = createAsyncAction(
  '@label/DELETE_QUICK_REPLY_REQUEST',
  '@label/DELETE_QUICK_REPLY_SUCCESS',
  '@label/DELETE_QUICK_REPLY_FAILURE'
)<Request, Success, Failure>()

const request = (
  state: QuickReplyState,
  action: ActionType<typeof deleteQuickReplyAction.request>
): QuickReplyState => ({
  ...state,
  isLoadingDeleteQuickReply: true
})

const success = (
  state: QuickReplyState,
  action: ActionType<typeof deleteQuickReplyAction.success>
): QuickReplyState => {
  return {
    ...state,
    isLoadingDeleteQuickReply: false,
    isSuccessOnDeleteQuickReply: true
  }
}

const failure = (
  state: QuickReplyState,
  action: ActionType<typeof deleteQuickReplyAction.failure>
): QuickReplyState => ({
  ...state,
  isLoadingDeleteQuickReply: false,
  isErrorOnDeleteQuickReply: true
})

export const deleteQuickReplyHandle = { asyncAction: deleteQuickReplyAction, request, success, failure }
